module.exports = __webpack_public_path__ + "img/gywmn1.ed302042.png";